import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import CtaStyle2 from '../Cta/CtaStyle2';
import AboutStyle7 from '../About/AboutStyle7';
import AboutStyle8 from '../About/AboutStyle8';
import { pageTitle } from '../../helpers/PageTitle';
import { Icon } from '@iconify/react';


export default function PackagingDesign() {
  pageTitle('Portfolio Details');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Packaging That Speaks Before the Product Does"
        subTitle="Packaging Design"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <div className="cs_portfolio_details">

          {/* <thu src="/images/packcover.mp4" alt="Thumb" /> */}
          <video
            src="/images/packcover.mp4"
            controls
            autoPlay
            muted
            loop
            style={{ width: '100%' }}  // 16px = rounded-2xl approx.
            className="custom-video"
          />

          <Spacing lg="100" md="40" />
          <div className="cs_portfolio_details_in">
            <ul className="cs_portfolio_details_info cs_mp0">
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Client:</h3>
                <p className="mb-0">Andrew romania</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Location:</h3>
                <p className="mb-0">United Kindom</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Budget:</h3>
                <p className="mb-0">$2500</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">
                  Project Completed:
                </h3>
                <p className="mb-0">11 August,2022</p>
              </li>
            </ul>
            <div className="cs_portfolio_details_right">
              <h2>Project Summary</h2>
              <p>
                At Brandgazm, packaging isn’t just a container — it’s your brand’s first physical impression, and we make sure it hits like a statement piece. We craft packaging that feels as good as it looks — tailored, tactile, and irresistibly on-brand. From luxury textures and smart structural design to stunning visuals and intentional copy, every element is curated to elevate your product and captivate your audience at first glance. Whether it’s on a retail shelf or an unboxing video, we design packaging that doesn’t whisper — it speaks volumes. Premium, powerful, and impossible to ignore.
              </p>
            </div>
          </div>
          <Spacing lg="115" md="60" />
          <div className="cs_portfolio_details_gallery">
          <div>
              <img src="/images/pack02.png" alt="Thumb" />
            </div>
            <div>
              <img src="/images/pack03.png" alt="Thumb" />
            </div>
            <div>
              <img src="/images/pack04.png" alt="Thumb" />
            </div>
           
          </div>
        </div>
        <Spacing lg="90" md="60" />
        {/* <div className="cs_page_navigation cs_center">
           <div>
             <a href="/" className="cs_text_btn cs_type1">
               <Icon icon="cil:arrow-left" className="cs_fs_21" />
               <span>Prev Project</span>
             </a>
           </div>
           <div>
             <a href="/" className="cs_text_btn">
               <span>Next Project</span>
               <Icon icon="cil:arrow-right" className="cs_fs_21" />
             </a>
           </div>
         </div> */}
      </div>
      <Spacing lg="150" md="80" />
    </>
  );
}
